export const capitalize = (lowerString: string): string => {
  const lower = lowerString.toLowerCase()
  return lowerString.charAt(0).toUpperCase() + lower.slice(1)
}

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

export const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char])

export const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const truncateTextWithEllipsis = (text: string | undefined | null, maxLength: number, suffix: string = '...'): string => {
  if (!text || text.length <= maxLength) {
    return text || '';
  }
  return text.substring(0, maxLength) + suffix;
};